import { render, staticRenderFns } from "./ImmediateWorkflowSelector.vue?vue&type=template&id=5c0a8651"
import script from "./ImmediateWorkflowSelector.vue?vue&type=script&lang=js"
export * from "./ImmediateWorkflowSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports